import React, { FC } from 'react';
import Typography from '@material-ui/core/Typography';

interface Props {
    value: string;
    className?: string;
    style?: React.CSSProperties;
}

const Title: FC<Props> = p => {

    return (
        <>
            <Typography
                align="center"
                variant="h4"
                className={p.className}
                style={p.style}
            >
                {p.value}
            </Typography>
        </>
    );
}

export default Title;
